import { render } from "./Main.vue?vue&type=template&id=1e978ce7&scoped=true"
const script = {}

import "./Main.vue?vue&type=style&index=0&id=1e978ce7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1e978ce7"

export default script